import {
  Box,
  Dialog,
  DialogContent,
  IconButton,
  Link,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import Booking from "./Booking";
import Embed from "./Embed";
import EmbedButton from "./EmbedButton";
import SocialShare from "./SocialShare";
import { X } from "react-feather";
import { useNavigate } from "react-router-dom";

const ShareDialog = ({
  open,
  close,
  bookingURL,
  hasHeaderOption = false,
  type = "booking",
  package_category = "consultation",
  package_count = {},
}) => {
  const [category, setCategory] = useState("booking"); //booking, embed, share, button
  const navigate = useNavigate();

  const onChangeCategory = (category) => {
    setCategory(category);
  };

  const onClose = () => {
    close();
    setCategory("booking");
  };

  const handleCreatePackage = () => {
    navigate(
      `/app/packages/${package_category === "courses" ? "new-course" : "new-digital"
      }`
    );
  };

  return (
    <Dialog
      open={open}
      onClose={() => console.log("uncloseable")}
      BackdropProps={{
        sx: {
          background: "#060a2dcc",
        },
      }}
      PaperProps={{
        sx: {
          width: { xs: "100%", sm: "480px" },
          borderRadius: "12px",
        },
      }}
      scroll="body"
    >
      <DialogContent sx={{ p: 0 }}>
        {/* hide share when package (digital-products or courses) is not available */}
        {(package_category === "digital-products" &&
          package_count?.digital === 0) ||
          (package_count?.course === 0 && package_category === "courses") ? (
          <Box>
            <Box
              sx={{
                p: "20px",
              }}
            >
              <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                <IconButton onClick={() => close()}>
                  <X size={20} />
                </IconButton>
              </Box>

              <Box sx={{ mt: "4px" }}>
                <Typography
                  sx={{
                    fontFamily: "var(--font-grenettepromedium)",
                    fontStyle: "normal",
                    fontSize: "26px",
                    lineHeight: "26px",
                    letterSpacing: "-0.01em",
                    color: "#000000",
                    textAlign: "center",
                  }}
                >
                  No {package_category} to share
                </Typography>
              </Box>

              <Box sx={{ mt: "8px" }}>
                <Typography
                  sx={{
                    fontWeight: 400,
                    fontSize: "14px",
                    lineHeight: "18px",
                    textAlign: "center",
                    color: "#6E757C",
                  }}
                >
                  {" "}
                  Seems like you don't have any {package_category} to share.
                </Typography>

                <Typography
                  sx={{
                    mt: "16px",
                    fontWeight: 400,
                    fontSize: "14px",
                    lineHeight: "18px",
                    textAlign: "center",
                    color: "#6E757C",
                  }}
                >
                  You can{" "}
                  <Link
                    sx={{ cursor: "pointer" }}
                    onClick={handleCreatePackage}
                  >
                    {" "}
                    click here
                  </Link>{" "}
                  to create a new {package_category}.
                </Typography>
              </Box>
            </Box>
          </Box>
        ) : (
          <Box>
            {category === "booking" && (
              <Booking
                bookingURL={bookingURL}
                close={onClose}
                onChangeCategory={onChangeCategory}
                type={type}
                package_category={package_category}
                setCategory={setCategory}
              />
            )}

            {category === "embed" && (
              <Embed
                bookingURL={bookingURL}
                close={onClose}
                onChangeCategory={onChangeCategory}
                hasHeaderOption={hasHeaderOption || type === "website"}
              />
            )}

            {category === "share" && (
              <SocialShare
                bookingURL={bookingURL}
                close={onClose}
                onChangeCategory={onChangeCategory}
              />
            )}

            {category === "button" && (
              <EmbedButton
                bookingURL={bookingURL}
                close={onClose}
                onChangeCategory={onChangeCategory}
              />
            )}
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ShareDialog;
